import React from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import SketchfabSingleModel from '../common/SketchfabSingleModel'

const FashionModeling = () => {
  return (
    <>
      <Card className="fashion-modeling-container text-center no-border rounded-0 container">
      <Card.Body>
        <Card.Title className='fashion-modeling-title py-1'>Fashion Modeling</Card.Title>
        <Card.Text className='fashion-modeling-text py-1'>
        Techniques continue to advance for modeling cloth, hair, fur and other soft stylings that flow and move in use. So, now in addition to virtual photography use in fashion marketing, “virtual try on” of clothing in AR is becoming the new standard expected from consumers, who want to see themselves rather than a model wearing clothing that naturally follows their movements.
        </Card.Text>
        <Row className='pt-1 pt-md-5'>
            <Col id="first" sm={12} md={7}>
                <div className="fashion-modeling-player">
                    <SketchfabSingleModel  modelId="d31929fcfedb49dca7965bee1b6da8ac"  />
                </div>
            </Col>
            <Col id="second" sm={12} md={5} className="fashion-grid">
                <Row sm={1} md={2} className='g-4 fashion-modeling-grid'>
                    <Col className="fashion-modeling-thumbnail">
                        <img className="fashion-modeling-image" src={process.env.PUBLIC_URL + "assets/fashion/thumbnail/dress01.jpg"} alt=" " />
                    </Col>
                    <Col className="fashion-modeling-thumbnail">
                        <img className="fashion-modeling-image" src={process.env.PUBLIC_URL + "assets/fashion/thumbnail/dress02.jpg"} alt=" " />
                    </Col>
                {/* </Row>
                <Row> */}
                    <Col className="fashion-modeling-thumbnail">
                        <img className="fashion-modeling-image" src={process.env.PUBLIC_URL + "assets/fashion/thumbnail/dress04.jpg"} alt=" " />
                    </Col>
                    <Col className="fashion-modeling-thumbnail">
                        <img className="fashion-modeling-image" src={process.env.PUBLIC_URL + "assets/fashion/thumbnail/dress03.jpg"} alt=" " />
                    </Col>
                </Row>
            </Col>
        </Row>
      </Card.Body>
    </Card>
    </>
  )
}

export default FashionModeling
